import axios from "axios";
import { useState, useEffect } from "react";

const useContactUs = () => {
  const [contactUs, setContactUs] = useState([]);
  const [loading, setLoading] = useState(false);

  const rupali_api_url = process.env.REACT_APP_RUPALI_API_HOST;

  const url = `${rupali_api_url}/Api/WebSite/ContactInfo`;

  useEffect(() => {
    axios.get(url).then((res) => {
      setContactUs(res.data.data[0]);
      setLoading(true);
    });
  }, []);

  return [contactUs, setContactUs, loading];
};

export default useContactUs;
